"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_MORE_SKELETON = void 0;
const LOAD_MORE_SKELETON = exports.LOAD_MORE_SKELETON = 'load-more-skeleton';
